import Category from "@/models/category";

export default class CategoryFactory {
  static createFromJson(json) {
    return new Category(json);
  }
  static createFromJsonArray(jsonArray) {
    const jsonData = [];
    jsonArray.forEach((item) => {
      jsonData.push(CategoryFactory.createFromJson(item));
    });

    return jsonData;
  }
}
